import { parseBooleanValue } from "../../util";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";

const IndexTypeGroupParamMapper = (item: IIndexTypeGroup) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default IndexTypeGroupParamMapper;
